var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dc-certificates"},[_c('app-docs',{attrs:{"docs":_vm.certificates,"list":false,"title":"Documenti allegati","layout-label":"Visualizzazione","cover-alt":"Copertina"}}),_vm._v(" "),_c('app-share-button',{attrs:{"label":"Condividi"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36669e62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/download-center/Certificates.vue
// module id = null
// module chunks = 